import React from "react";
import Spinner from "../Spinner";
import styles from "./FullScreenSpinner.module.css";

const FullScreenSpinner = () => (
    <div className={styles.fullScreenSpinner}>
        <Spinner size="xxlarge" color="text-content-accent" />
    </div>
);

export default FullScreenSpinner;
